export default __webpack_public_path__ + "static/media/quora.d7e90904.png";